import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import { dispatch } from '../store';

const initialState = {
  newProductList: {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  },
  isGettingNewProductList: false,

  recommendedProductList: {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  },
  isGettingRecommendedProductList: false,

  searchResultList: {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  },
  isGettingSearchResultList: false,
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setNewProductList: (state, action) => {
      var data = action.payload;
      state.newProductList = {
        ...data,
        results: [...state.newProductList.results, ...data.results],
      };
    },
    setIsGettingNewProductList: (state, action) => {
      var data = action.payload;
      state.isGettingNewProductList = data;
    },
    clearNewProductList: (state) => {
      var newState = {
        next: 1,
        previous: null,
        current_page: 1,
        count: 1,
        total_pages: 1,
        results: [],
      };
      state.newProductList = newState;
    },

    setRecommendedProductList: (state, action) => {
      var data = action.payload;
      state.recommendedProductList = {
        ...data,
        results: [...state.recommendedProductList.results, ...data.results],
      };
    },
    setIsGettingRecommendedProductList: (state, action) => {
      var data = action.payload;
      state.isGettingRecommendedProductList = data;
    },
    clearRecommendedProductList: (state) => {
      var newState = {
        next: 1,
        previous: null,
        current_page: 1,
        count: 1,
        total_pages: 1,
        results: [],
      };
      state.recommendedProductList = newState;
    },

    setSearchResultList: (state, action) => {
      var data = action.payload;
      state.searchResultList = {
        ...data,
        results: [...state.searchResultList.results, ...data.results],
      };
    },
    setIsGettingSearchResultList: (state, action) => {
      var data = action.payload;
      state.isGettingSearchResultList = data;
    },
    clearSearchResultList: (state) => {
      var newState = {
        next: 1,
        previous: null,
        current_page: 1,
        count: 1,
        total_pages: 1,
        results: [],
      };
      state.searchResultList = newState;
    },
  },
});

export const {
  setNewProductList,
  clearNewProductList,
  setIsGettingNewProductList,
  setRecommendedProductList,
  setIsGettingRecommendedProductList,
  clearRecommendedProductList,

  setSearchResultList,
  setIsGettingSearchResultList,
  clearSearchResultList,
} = productsSlice.actions;

export default productsSlice.reducer;

export const handleClearProductList = () => {
  dispatch(clearNewProductList());
};

export const handleGettingNewProductList = async (page) => {
  if (page) {
    dispatch(setIsGettingNewProductList(true));

    try {
      var link = `ecommerce/product/list/?page=${page}&status=Active&query=&page_size=10&order_by=-created_at`;

      const res = await axios.get(link);
      if (res.status === 200) {
        if (parseInt(page, 10) === 1) {
          dispatch(clearNewProductList());
        }
        const data = res.data;
        dispatch(setNewProductList(data));
        dispatch(setIsGettingNewProductList(false));
      }
      return Promise.resolve();
    } catch (err) {
      dispatch(setIsGettingNewProductList(false));
      return Promise.reject(err);
    }
  }
};

export const handleGettingRecommendedProductList = async (page) => {
  if (page) {
    dispatch(setIsGettingRecommendedProductList(true));

    try {
      var link = `ecommerce/product/list/?page=${page}&status=Active&query=&page_size=10&order_by=-sold_out`;

      const res = await axios.get(link);
      if (res.status === 200) {
        if (parseInt(page, 10) === 1) {
          dispatch(clearRecommendedProductList());
        }
        const data = res.data;
        dispatch(setRecommendedProductList(data));
        dispatch(setIsGettingRecommendedProductList(false));
      }
      return Promise.resolve();
    } catch (err) {
      dispatch(setIsGettingRecommendedProductList(false));
      return Promise.reject(err);
    }
  }
};

export const handleSearchProduct = async (query, page) => {
  if (page) {
    dispatch(setIsGettingSearchResultList(true));

    try {
      var link = `ecommerce/product/list/?page=${page}&status=Active&query=${query}&page_size=10&order_by=-created_at`;

      const res = await axios.get(link);
      if (res.status === 200) {
        if (parseInt(page, 10) === 1) {
          dispatch(clearSearchResultList());
        }
        const data = res.data;
        dispatch(setSearchResultList(data));
        dispatch(setIsGettingSearchResultList(false));
      }
      return Promise.resolve();
    } catch (err) {
      dispatch(setIsGettingSearchResultList(false));
      return Promise.reject(err);
    }
  }
};
